import { render } from "./PriceManager.vue?vue&type=template&id=1dcf447a&scoped=true"
import script from "./PriceManager.vue?vue&type=script&lang=js"
export * from "./PriceManager.vue?vue&type=script&lang=js"

import "./PriceManager.vue?vue&type=style&index=0&id=1dcf447a&scoped=true&lang=css"

import exportComponent from "/Users/david/Desktop/projects/ConexionCreativa/real-gestion/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dcf447a"]])

export default __exports__